<div ngModelGroup="companyRegistrationDTO">
  <div class="d-flex flex-column gap-3">
    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformCompanyRegistrationDTO.companyName"
                   [min]="0"
                   class="w-100"
                   formInlineError="platform-administration.company.legal-entity.errors"
                   id="companyName"
                   name="companyName"
                   bsInputText
                   required
                   type="text" data-testid="company-name-input">
            <label for="companyName">{{'platform-administration.company.legal-entity.inputs.companyName' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformCompanyRegistrationDTO.registrationCode"
                   [min]="0"
                   class="w-100"
                   formInlineError="platform-administration.company.legal-entity.errors"
                   id="registrationCode"
                   name="registrationCode"
                   bsInputText
                   required
                   type="text" data-testid="registration-code-input">
            <label for="registrationCode">{{'platform-administration.company.legal-entity.inputs.registrationCode' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformCompanyRegistrationDTO.uniqueIdentificationNumber"
                   [min]="0"
                   class="w-100"
                   formInlineError="platform-administration.company.legal-entity.errors"
                   id="uniqueIdentificationNumber"
                   name="uniqueIdentificationNumber"
                   bsInputText
                   required
                   type="text" data-testid="unique-identification-number-input">
            <label for="uniqueIdentificationNumber">{{'platform-administration.company.legal-entity.inputs.uniqueIdentificationNumber' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformCompanyRegistrationDTO.preferredLanguage"
                   [min]="0"
                   class="w-100"
                   formInlineError="platform-administration.company.legal-entity.errors"
                   id="preferredLanguage"
                   name="preferredLanguage"
                   bsInputText
                   required
                   type="text" data-testid="preferred-language-input">
            <label for="preferredLanguage">{{'platform-administration.company.legal-entity.inputs.preferredLanguage' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformCompanyRegistrationDTO.mainPhoneNumber"
                   [min]="0"
                   class="w-100"
                   id="mainPhoneNumber"
                   name="mainPhoneNumber"
                   bsInputText
                   type="text" data-testid="main-phone-number-input">
            <label for="mainPhoneNumber">{{'platform-administration.company.legal-entity.inputs.mainPhoneNumber' | translate}} </label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformCompanyRegistrationDTO.mainEmailAddress"
                   [min]="0"
                   class="w-100"
                   id="mainEmailAddress"
                   name="mainEmailAddress"
                   bsInputText
                   type="text" data-testid="main-email-address-input">
            <label for="mainEmailAddress">{{'platform-administration.company.legal-entity.inputs.mainEmailAddress' | translate}} </label>
          </p-floatlabel>
    </div>
  </div>
</div>


